import { render } from "./ModalKalkulator.vue?vue&type=template&id=2684796e"
import script from "./ModalKalkulator.vue?vue&type=script&lang=js"
export * from "./ModalKalkulator.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__